import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Form, Select } from 'semantic-ui-react';

import { useClosableForm } from '../../hooks';

import styles from './DeviceAdd.module.scss';

const DeviceAdd = React.memo(({ siteId, lineId, devices, isOpened, onCreate, onClose }) => {
  const [t] = useTranslation();

  const [deviceID, setDeviceID] = useState(0);

  const submit = useCallback(() => {
    const cleanData = {
      id: deviceID,
      lineId,
      siteId,
      isCreate: false,
    };
    onCreate(cleanData);
    onClose();
  }, [onClose, onCreate, deviceID, lineId, siteId]);

  const [handleFieldBlur, handleControlMouseOver, handleControlMouseOut] = useClosableForm(onClose);

  const handleSubmit = useCallback(() => {
    submit();
  }, [submit]);

  const handleDropDownSelect = (event, selected) => {
    setDeviceID(selected.value);
  };

  const devicesOptions = [];
  devices.forEach((item) => devicesOptions.push({ key: item.id, value: item.id, text: item.name }));
  return (
    <Form
      className={classNames(styles.wrapper, !isOpened && styles.wrapperClosed)}
      onSubmit={handleSubmit}
    >
      <div className={styles.fieldWrapper}>
        <Select
          className={`dropdown-add-device ${styles.fieldDropdown}`}
          placeholder={t('common.selectDevice')}
          search
          fluid
          selection
          onChange={handleDropDownSelect}
          options={devicesOptions}
          onBlur={handleFieldBlur}
          defaultValue={deviceID}
        />
      </div>
      <div className={styles.controls}>
        {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
        <Button
          positive
          content={t('action.addDevice')}
          className={styles.submitButton}
          onMouseOver={handleControlMouseOver}
          onMouseOut={handleControlMouseOut}
        />
      </div>
    </Form>
  );
});

DeviceAdd.propTypes = {
  siteId: PropTypes.string.isRequired,
  lineId: PropTypes.string.isRequired,
  devices: PropTypes.arrayOf(PropTypes.any).isRequired,
  isOpened: PropTypes.bool.isRequired,
  onCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeviceAdd;
